import { Component, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'bwc-success-popup',
  templateUrl: './success-popup.component.html',
  styleUrls: ['./success-popup.component.scss'],
})
export class SuccessPopupComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<SuccessPopupComponent>, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'success-popup');
    localStorage.setItem('bwh_account_created', 'true');
    sessionStorage.removeItem('bwh_is_manual_flow');
    sessionStorage.removeItem('bwh_uploaded_file_name');
  }
  getRange(count: number): number[] {
    return Array.from({ length: count }, (_, index) => index);
  }

  submit() {
    this.dialogRef.close();
  }
}
